<template>
  <div class="container py-2 d-flex flex-column justify-content-between h-100">
    <div class="row">
      <div class="col-8">
        <DetailsPriceSummary />
      </div>
      <div class="col-4">
        <OrderButtonGroup />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <OrderInfo />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import DetailsPriceSummary from './DetailsPriceSummary.vue'
import OrderButtonGroup from './OrderButtonGroup.vue'
import OrderInfo from './OrderInfo.vue'

export default defineComponent({
  components: {
    OrderButtonGroup,
    DetailsPriceSummary,
    OrderInfo,
  },
})
</script>

<style lang="scss" scoped>
@import '../../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.container {
  height: 240px;
}
</style>
